"use client";

// src/utils/get-icon-by-filename.ts
import {
  SiJavascript,
  SiMarkdown,
  SiMdx,
  SiNodedotjs,
  SiReact,
  SiTypescript
} from "@icons-pack/react-simple-icons";
import { FileIcon, TerminalIcon } from "lucide-react";
var icons = [
  {
    extensions: ["js", "mjs", "cjs"],
    icon: SiJavascript
  },
  {
    extensions: ["ts", "mts", "cts"],
    icon: SiTypescript
  },
  {
    extensions: ["jsx", "tsx"],
    icon: SiReact
  },
  {
    extensions: ["sh", "bash", "zsh"],
    icon: TerminalIcon
  },
  {
    extensions: ["md"],
    icon: SiMarkdown
  },
  {
    extensions: ["mdx"],
    icon: SiMdx
  },
  {
    filenames: ["package.json"],
    icon: SiNodedotjs
  }
];
var filenameToIcon = /* @__PURE__ */ new Map();
var extensionToIcon = /* @__PURE__ */ new Map();
for (const icon of icons) {
  if (icon.filenames) {
    for (const filename of icon.filenames) {
      filenameToIcon.set(filename, icon.icon);
    }
  }
  if (icon.extensions) {
    for (const extension of icon.extensions) {
      extensionToIcon.set(extension, icon.icon);
    }
  }
}
var getIconByFilename = (filename) => {
  if (filenameToIcon.has(filename)) {
    return filenameToIcon.get(filename);
  }
  const extension = filename.split(".").pop();
  if (extension && extensionToIcon.has(extension)) {
    return extensionToIcon.get(extension);
  }
  return FileIcon;
};

export {
  getIconByFilename
};
